// @vendors
const Inmutable = require('immutable');
const moment = require('moment');
//@utilities
const { formatAmount, decimalsLength, getFormattedString } = require('utilities/currencyHelper');
const { getTaeInfo } = require('../../../loansUtilities/loansHelper');
// @constants
const types = require('../../../loansConstants/paymentDayType');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');

const mapContractingData = (contractingData, paymentDayType) => {
  const currency = contractingData.get('currency');
  const taeInfo = getTaeInfo(contractingData, paymentDayType);

  return (
    Inmutable.fromJS({
      currency,
      installment: {
        amount: contractingData.get('monthlyFee'),
        currency,
        decimalsLength: decimalsLength(contractingData.get('monthlyFee')),
      },
      totalAmount: (taeInfo && taeInfo.get('totalAmount') ) || contractingData.get('amount'),
      selectedAmount: contractingData.get('amount'),
      selectedTerm: contractingData.get('term'),
      tin: contractingData.get('tin'),
      tae: (taeInfo && taeInfo.get('tae')) || 0,
      arrangementFee: formatAmount(0), // always 0 in ARES loan
      arrangementPercentage: contractingData.get('openingFee'), // always 0 in ARES loan
      isCollective: false,
      collectiveInformation: [{}]
    })
  );
};

const mapSegementedLoanInfo = (contractingData, taeInfo) => ({
  partenonSegmentedLoanData : {
    openingFee : '0,00', // default value, '0,00', always 0 in ARES Loan
    minOpeningFee : '0,00', // default value, '0,00', always 0 in ARES Loan
    productTypeDescription : 'PRESTAMO ARES', // default value, 'PRESTAMO ARES'
    longProductTypeDescription : 'PRESTAMO ARES', // default value, 'PRESTAMO ARES'
    currencyDescription : 'EURO', // default value, 'EURO'
    currency: contractingData.get('currency'),
    shortageIndicator : 'NO', // default value, 'NO'
    shortageInstallmentsNumber : '0', // default value, '0'
    anniversaryStandard : taeInfo && taeInfo.get('productStandard'),
    anniversaryProductType: contractingData.get('productType'),
    anniversaryProductSubType: contractingData.get('productSubtype').toString(),
  },
  referenceSegmentedLoan : {
    standard : taeInfo && taeInfo.get('productStandard'),
    type: contractingData.get('productType'),
    subType: contractingData.get('productSubtype').toString(),
  }
});

const mapDocumentsRequest = (dossier, paymentDayType, selectedAccount) => {
  const contractingData = dossier.get('contractingData');
  const proposalData = contractingData.get('proposalData');
  const riskData = dossier.get('riskData');
  const taeInfo = getTaeInfo(contractingData, paymentDayType);
  const segmentedLoan = mapSegementedLoanInfo(contractingData, taeInfo);
  
  return {
    hiringDocumentsPrivateRequest : {
      amount: formatAmount(contractingData.get('amount')), // 1.000,00
      calculatedOpeningCommission: formatAmount(contractingData.get('openingFee')), // 0,00
      capitalizedOpeningCommissionIndicator: 'N', // default value, 'N'
      clientAccountCode: selectedAccount.get('iban'),
      dueDate: moment(proposalData.get('dueDate')).format(DATE_FORMAT_WITH_SLASHES), // DD/MM/YYYY
      isEndOfMonth: paymentDayType === types.END_OF_MONTH, // END_OF_MONTH -> true
      financedCommission: 'NO FINANCIADA       ', // default value, we need to send to backend 20 chars.
      isFirstTime: true, // default value, true
      loanPurpose: riskData.get('purpose'),
      productDuration: contractingData.get('term').toString(),
      propositionContractNumber: proposalData.get('contract').get('contractNumber'),
      propositionNumber: proposalData.get('proposal').get('proposalNumber'),
      tae: formatAmount((taeInfo && taeInfo.get('tae')) || 0),
      tin: formatAmount(contractingData.get('tin')),
      year: proposalData.get('proposal').get('year'),
    },
    segmentedLoan,
  };
};

const mapFinalizationRequest = (dossier, selectedAccount, paymentDayType, acceptedText) => {
  const contractingData = dossier.get('contractingData');
  const proposalData = contractingData.get('proposalData');
  const riskData = dossier.get('riskData');
  const taeInfo = getTaeInfo(contractingData, paymentDayType);
  const segmentedLoan = mapSegementedLoanInfo(contractingData, taeInfo);

  return {
    accountBban: selectedAccount.get('iban'), // IBAN OLD CODE
    accountContractNumber: selectedAccount.get('newContractNumber'), // last 7 digits - new code
    accountPrefix: selectedAccount.getIn(['ibanComplex', 'pais']) + selectedAccount.getIn(['ibanComplex', 'digitodecontrol']), // first 4 digits
    capitalizedOpeningCommissionIndicator: 'N', // default value 'N',
    dueDate: moment(new Date(Date.now())).format('YYYY-MM-DD'), // current date YYYY-MM-DD,
    endOfMonth: paymentDayType === types.END_OF_MONTH, // END_OF_MONTH -> true
    endOfMonthDate: contractingData.get('paymentDay').toString(), // only the day
    financedCommission: false, // default value false,
    firstChargeDate: moment(new Date(Date.now())).format('YYYY-MM-DD'), // YYYY-MM-DD TODO ELiminar
    installment: contractingData.get('monthlyFee').toString(), // string
    product: selectedAccount.get('newProduct'), // values between 14 and 16 characters - new code
    productType: contractingData.get('productType'), // '023',
    propositionContractNumber: proposalData.get('contract').get('contractNumber').toString(), // '023', string
    propositionContractProduct: proposalData.get('contract').get('product'), // '023',
    propositionNumber: proposalData.get('proposal').get('proposalNumber').toString(), // '54', string
    registerDate: proposalData.get('dueDate'), // 'YYYY-MM-DD',
    tae: formatAmount((taeInfo && taeInfo.get('tae')) || 0), // '5,16',
    termsAndConds: { acceptedText },
    year: proposalData.get('proposal').get('year').toString(), // '2022', string
    purpose: riskData.get('purpose'), // 'PRESTAMO VIVIENDA',
    amount: parseInt(contractingData.get('amount')), // 1.000,00,
    tin: parseInt(contractingData.get('tin'), 10), // int
    term: parseInt(contractingData.get('term'), 10), // int
    segmentedLoan,
  };
}

const mapTotalCostInfo = (contractingData, paymentDayType) => {
  const taeInfo = getTaeInfo(contractingData, paymentDayType);
  return getFormattedString({
      amount: taeInfo.get('totalCost') || 0,
      currency: contractingData.get('currency'),
      decimalsLength: decimalsLength(taeInfo.get('totalCost') || 0),
  });
}

const mapPrecontractualMailRequest = (dossier, paymentDayType, selectedAccount, acceptedText) => {
  const contractingData = dossier.get('contractingData');
  const proposalData = contractingData.get('proposalData');
  const riskData = dossier.get('riskData');
  const taeInfo = getTaeInfo(contractingData, paymentDayType);

  return {
    producto: contractingData.get('productType'),
    standard: taeInfo && taeInfo.get('productStandard'),
    subproducto: contractingData.get('productSubtype').toString(),
    templateCode: 'precontractual_ares', // default value, 'precontractual_ares',
    termsAndConds: { acceptedText },
    hiringDocumentsAresRequest: {
      hiringDocumentsRequest: {
        amount: formatAmount(contractingData.get('amount')), // 1.000,00
        calculatedOpeningCommission: formatAmount(contractingData.get('openingFee')), // 0,00
        capitalizedOpeningCommissionIndicator: 'N', // default value, 'N'
        clientAccountCode: selectedAccount.get('iban'),
        dueDate: moment(proposalData.get('dueDate')).format(DATE_FORMAT_WITH_SLASHES), // DD/MM/YYYY
        endOfMonth: paymentDayType === types.END_OF_MONTH, // END_OF_MONTH -> true
        financedCommission: 'NO FINANCIADA       ', // default value, we need to send to backend 20 chars.
        firstTime: true, // default value, true
        loanPurpose: riskData.get('purpose'),
        productDuration: contractingData.get('term').toString(),
        propositionContractNumber: proposalData.get('contract').get('contractNumber'),
        propositionNumber: proposalData.get('proposal').get('proposalNumber'),
        tae: formatAmount((taeInfo && taeInfo.get('tae')) || 0),
        tin: formatAmount(contractingData.get('tin')),
        year: proposalData.get('proposal').get('year'),
        productType: contractingData.get('productType')
      },
      segmentedLoan: {
        datosPrestamoPartenonSegmentados: {
          comisionApertura: '0,00', // default value, '0,00', always 0 in ARES Loan
          comisionAperturaMin: '0,00', // default value, '0,00', always 0 in ARES Loan
          descripcionDivisa: 'Euros', // default value, 'Euros'
          divisa: contractingData.get('currency'),
          indicadorCarencia: 'NO', // default value, 'NO'
          numeroCuotasCarencia: '0', // default value, '0'
          erPagoAniversario:  taeInfo && taeInfo.get('productStandard'),
          tipoPagoAniversario: contractingData.get('productType'),
          subtipoPagoAniversario: contractingData.get('productSubtype').toString(),
      },      
        referencia: {
          estandar:  taeInfo && taeInfo.get('productStandard'),
          tipo: contractingData.get('productType'),
          subtipo: contractingData.get('productSubtype').toString(),
        }
      }
    }
  };
}

module.exports = {
  mapContractingData,
  mapDocumentsRequest,
  mapFinalizationRequest,
  mapTotalCostInfo,
  mapPrecontractualMailRequest,
}